module.exports = __webpack_public_path__ + "static/media/module_open_explore.38965bb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/modules/module_open_explore.png
// module id = ./src/resources/images/modules/module_open_explore.png
// module chunks = 0